import React from "react";
import { RxArrowRight } from "react-icons/rx";

export default function CardArticle(props) {
  return (
    <div className="h-[400px] lg:h-[420px] relative rounded-xl shadow-lg border-2 border-blue-200">
      <img className="" src={props.imageSource} alt="" />
      <h3 className="font-bold p-8 text-lg">{props.title}</h3>
      <p className="absolute text-end text-sm  mr-5 text-blue-800 hover:text-blue-500 cursor-pointer flex items-center justify-end mb-6 bottom-0 right-0">
        Baca Selengkapnya <RxArrowRight className="ml-3" />
      </p>
    </div>
  );
}
